import Vue from 'vue'

import { $error, $warn, $success } from '@/utils/prompt'

// 工具类插件
const utilsPlugin = {
  install (Vue, options) {
    // 提示方法
    Vue.prototype.$success = $success
    Vue.prototype.$warn = $warn
    Vue.prototype.$error = $error
  },
}

Vue.use(utilsPlugin)
